export const accessTypeAllowed = {
  SCAN: "SCAN",
  REMOTE: "REMOTE",
}

export const accessTypeAllowedLabel = {
  [accessTypeAllowed.SCAN]: "Escáner",
  [accessTypeAllowed.REMOTE]: "Control"
}